import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Update,
  GetById,
} from "adminApi/ItemsUnitApi/ItemsUnit";
import fields from "../json/ItemsUnitFields.json";
import { validateForm } from "utils/validation";
import { ItemsUnitRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditItemsUnitForm from "./Componates/EditItemsUnitForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const EditItemsUnit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { formdata } = fields;

  // Initialize form values
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setErrors, setValues } = useFormChange(initialValues, ItemsUnitRules);

  // Fetch existing data by ID
  const { loading: loadingFetch } = useFetchFormDataById(id, formdata, GetById, setValues);

  // Form submit hook
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await Update({ id, data: formData });
    },
    (vals) => {
      const err = validateForm(vals, ItemsUnitRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Item Unit updated successfully"
  );
  return (
    <>
      {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}
      <EditItemsUnitForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Edit Item Unit Type"
      />
    </>
  );
};

export default EditItemsUnit;
